// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"537d8190","340":"ac638907","540":"5e60e17b","563":"bf92e30e"}[chunkId] + ".chunk.css";
};